import { useProfile, useUser } from 'models';
import { useState } from "react";
import { User } from "./user";

export class Profile{
  constructor(user){
    if(user.isLogged()){
      let data = user.profile
      this.id = data.id
      this.name = data.name
      this.routes = data.routes
      this.type = data.profile_type_id
    }
  }

  havePermission(permission){
    let aux = this.routes.filter(r => r.alias === permission)[0];
    if(aux){
      return true;
    }
    return false;
  }
}

export default function (){
  const user = useUser()
  const [ profile ] = useState(new Profile(user));

  return profile
}